import { ButtonStartOver } from "../partials/buttons";
import stylesConfig from "../styles.config";
import mediaQuery from "../abstract/media-query";

export default {
  container: {
    ...ButtonStartOver,
    marginLeft: "15px",
    "& svg path": {
      fill: stylesConfig.colors.secondary.spectrum500,
    },
    [mediaQuery.hover]: {
      "&:hover": {
        "& svg path": {
          fill: stylesConfig.colors.secondary.spectrum800,
        },
      },
    },
  },
};
